
import { Component, Mixins, Prop } from 'vue-property-decorator';
import MessageToastMixin from '@/mixins/MessageToastMixin';
import NewClaimFooterTotals from '@/components/claims/new-claim/NewClaimFooterTotals.vue';
import { SalesQuote } from '@/api';

@Component({
  components: { NewClaimFooterTotals },
})
export default class NewClaimFooter extends Mixins(MessageToastMixin) {
  @Prop(String)
  step!: string;

  @Prop(Boolean)
  nextActive!: boolean;

  loading = false;

  get agreement(): SalesQuote | undefined {
    return this.$store.getters['claim/agreement'];
  }

  get showTotals(): boolean {
    return this.step === 'claim-details';
  }

  get canGoNext(): boolean {
    return this.nextActive;
  }

  get nextLabel(): string {
    if (this.step === 'claim-summary') {
      return 'submit';
    }
    return 'next';
  }

  goNext() {
    if (!this.canGoNext) {
      return;
    }
    switch (this.step) {
      case 'claim-details':
        this.$router.push({
          name: 'new-claims-steps',
          params: { step: 'claim-summary' },
        });
        break;
      case 'claim-summary':
        this.submitClaim();
        break;
      default:
        break;
    }
  }

  goPrevious() {
    switch (this.step) {
      case 'claim-details':
        this.$router.push({ name: 'agreements' });
        break;
      case 'claim-summary':
        this.$router.push({
          name: 'new-claims-steps',
          params: { step: 'claim-details' },
        });
        break;
      default:
        break;
    }
  }

  async submitClaim() {
    try {
      this.loading = true;
      await this.$store.dispatch('claim/postClaim');
      this.$router.push({ name: 'agreements' });
      this.$buefy.dialog.alert({
        title: this.$t('claims.new.confirm-dialog.title') as string,
        message: this.$t('claims.new.confirm-dialog.message') as string,
        confirmText: this.$t('claims.new.confirm-dialog.button') as string,
      });
    } catch (e) {
      this.showError(this.$t('general.messages.error'));
    } finally {
      this.loading = false;
    }
  }
}
